/* react-hooks/exhaustive-deps */
import { useFetchCorporateGroups } from '../../../utils/queries/corporate';
import {
  useAddCorporateUserMutation,
  useEditCorporateUserMutation,
  useUserSuggestions,
} from '../../../utils/queries/corporateUsers';
import ErrorText from '../../Reusable/ErrorText';
import * as Yup from 'yup';
import { Form, message } from 'antd';

import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button,
  Label,
} from 'reactstrap';
import '../../Reusable/gridStyle.css';

import { Formik, Field, ErrorMessage } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { cloneDeep, get } from 'lodash-es';

// const { Option } = Select;

export default function AddCorporateUserModal({
  type = '',
  corporateId,
  editCorporateUserObject = null,
  isModalVisible = false,
  closeAddCorporateUser,
  triggerRefreshList,
}) {
  const initialFormValue = {
    ID: '',
    JP_CORPORATE: corporateId,
    EMAIL: '',
    PHONE: '',
    NAME: '',
    EMPLOYEE: '',
    JP_CORPORATE_LOCATION: '',
    IS_ADMIN: false,
    IS_ACTIVE: true,
  };
  /**
   * Form validation
   */
  const validationSchema = Yup.object({
    EMAIL: Yup.string().required('Please enter email.'),
    NAME: Yup.string().required('Please enter name.'),
    PHONE: Yup.string().required('Please enter phone number.'),
    JP_CORPORATE_LOCATION: Yup.string().required('Please select group.'),
  });

  const { data: groups = [] } = useFetchCorporateGroups(corporateId);
  const [query, setQuery] = useState('');
  const [searchField, setSearchField] = useState('');
  const {
    data: users,
    isLoading: userSuggestionsLoading,
    isSuccess: userSuggestionsSuccess,
    refetch: refetchUserSuggestions,
  } = useUserSuggestions(query, corporateId, type === 'admins' ? 1 : 0);

  const formRef = useRef(null);
  const [formValues, setFormValues] = useState(initialFormValue);
  const [noUserFound, setNoUserFound] = useState(false);
  const { mutateAsync, isLoading } = useAddCorporateUserMutation();
  const { mutateAsync: updateMutation, isLoading: isLoadingUpdate } =
    useEditCorporateUserMutation();

  useEffect(() => {
    setNoUserFound(false);
  }, []);

  useEffect(() => {
    if (userSuggestionsLoading) setNoUserFound(false);
    if (userSuggestionsSuccess) setNoUserFound(true);
    setTimeout(() => setNoUserFound(false), 5000);
  }, [userSuggestionsLoading, userSuggestionsSuccess]);

  // useEffect(() => {
  //   if (users?.length > 0) {
  //     const formVal = formRef?.current?.values;
  //     setFormValues({
  //       ...formVal,
  //       EMAIL: users[0].EMAIL,
  //       PHONE: users[0].PHONE_NUMBER,
  //       NAME: users[0].NAME,
  //       EMPLOYEE: users[0].ID,
  //       JP_CORPORATE_LOCATION: editCorporateUserObject
  //         ? formValues?.JP_CORPORATE_LOCATION
  //         : '',
  //     });
  //   } else if (users?.length === 0) {
  //     setFormValues({
  //       ...formValues,
  //       EMAIL: searchField === 'EMAIL' ? query : '',
  //       PHONE: searchField === 'PHONE' ? query : '',
  //       NAME: '',
  //       EMPLOYEE: '',
  //     });
  //   }
  //   // eslint-disable-next-line
  // }, [users, query]);

  useEffect(() => {
    if (users?.length > 0) {
      const formVal = formRef?.current?.values;
      setFormValues({
        ...formVal,
        EMAIL: searchField === 'EMAIL' ? query : users[0].EMAIL,
        PHONE: searchField === 'PHONE' ? query : users[0].PHONE_NUMBER,
        NAME: users[0].NAME,
        EMPLOYEE: users[0].ID,
        JP_CORPORATE_LOCATION: editCorporateUserObject
          ? formValues?.JP_CORPORATE_LOCATION
          : '',
      });
    } else if (users?.length === 0) {
      setFormValues({
        ...formValues,
        EMAIL: searchField === 'EMAIL' ? query : '',
        PHONE: searchField === 'PHONE' ? query : '',
        NAME: '',
        EMPLOYEE: '',
      });
    }
    // eslint-disable-next-line
  }, [users]);

  useEffect(() => {
    if (users?.length === 0) {
      setFormValues({
        ...formValues,
        EMAIL: searchField === 'EMAIL' ? query : '',
        PHONE: searchField === 'PHONE' ? query : '',
        NAME: '',
        EMPLOYEE: '',
      });
    }
    // eslint-disable-next-line
  }, [users, query]);

  useEffect(() => {
    if (editCorporateUserObject) {
      const corporateUserObject = cloneDeep(editCorporateUserObject);
      setQuery(corporateUserObject.EMAIL);
      const editValues = {
        ID: corporateUserObject.ID,
        JP_CORPORATE: corporateUserObject.JP_CORPORATE,
        EMAIL: corporateUserObject.EMAIL,
        PHONE: corporateUserObject.PHONE_NUMBER,
        NAME: corporateUserObject?.NAME || '',
        EMPLOYEE: get(corporateUserObject, 'JP_CORPORATE_USERS.ID'),
        JP_CORPORATE_LOCATION: get(
          corporateUserObject,
          'JP_CORPORATE_USERS.JP_CORPORATE_LOCATION',
        ),
        IS_ADMIN: false,
        IS_ACTIVE:
          get(corporateUserObject, 'JP_CORPORATE_USERS.IS_ACTIVE') || false,
      };
      setFormValues(editValues);
    } else {
      if (groups?.data?.length === 1) {
        const formVal = {
          ...initialFormValue,
          JP_CORPORATE_LOCATION: groups?.data[0]?.ID,
        };
        setFormValues(formVal);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCorporateUserObject, isModalVisible, groups]);

  const getHeading = () => 'New User';

  const triggerClose = () => {
    setFormValues(initialFormValue);
    closeAddCorporateUser();
  };

  const onBlurSearchInput = (searchQuery, type) => {
    setFormValues(initialFormValue);
    setQuery(searchQuery);
    refetchUserSuggestions(searchQuery);
    setSearchField(type);
  };

  const onSubmit = (values, form) => {
    const request = {
      // ID: values.ID,
      EMPLOYEE: values.EMPLOYEE,
      IS_ACTIVE: values.IS_ACTIVE,
      JP_CORPORATE_LOCATION: values.JP_CORPORATE_LOCATION,
    };

    if (editCorporateUserObject?.ID) {
      const req = {
        ID: get(editCorporateUserObject, 'JP_CORPORATE_USERS.ID'),
        LOCATION: values.JP_CORPORATE_LOCATION,
        IS_ACTIVE: values.IS_ACTIVE,
      };
      updateMutation(req).then(
        (resp) => {
          if ((resp.data && resp.status === 200) || resp.status === 201) {
            setFormValues(initialFormValue);
            form.resetForm({ values: initialFormValue });
            triggerRefreshList();
            closeAddCorporateUser();
            message.success('User updated successfully.');
          } else {
            message.error(
              resp?.data?.message || 'Something went wrong. Please try again',
            );
          }
        },
        (error) => {
          message.error(
            error?.response?.data?.message ||
              'Something went wrong. Please try again',
          );
        },
      );
    } else {
      mutateAsync(request).then(
        (resp) => {
          if (resp.data && resp.status === 201) {
            setFormValues(initialFormValue);
            form.resetForm({ values: initialFormValue });
            triggerRefreshList();
            closeAddCorporateUser();
            message.success('User added successfully.');
          } else {
            message.error('Something went wrong. Please try again');
          }
        },
        (error) => {
          closeAddCorporateUser();
          message.error(
            error?.response?.data?.error ||
              error?.response?.data?.message ||
              'Something went wrong. Please try again',
          );
        },
      );
    }
  };

  return (
    <Modal
      isOpen={isModalVisible}
      toggle={triggerClose}
      // onOk={() => null}
      // onCancel={() => {
      //   closeAddCorporateUser();
      // }}
      // footer={null}
      // destroyOnClose
    >
      <ModalHeader
        style={{ padding: '5px 10px', margin: 10 }}
        toggle={closeAddCorporateUser}
      >
        <div style={{ fontSize: '20px' }}>{`${
          editCorporateUserObject ? 'Edit' : 'Add'
        } ${getHeading()}`}</div>
      </ModalHeader>
      <ModalBody>
        <Formik
          innerRef={formRef}
          initialValues={formValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values, form) => onSubmit(values, form)}
        >
          {({ values, setFieldValue, handleSubmit }) => (
            <Form
              className="relative"
              layout="vertical"
              onFinish={() => handleSubmit()}
            >
              <Row gutter={[14, 14]}>
                <Col sm="10" md="5" lg="5">
                  <Form.Item
                    label={
                      <div>
                        Email<span className="mandatorystar">*</span>
                      </div>
                    }
                  >
                    <Field
                      as={Input}
                      name="EMAIL"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter')
                          onBlurSearchInput(e.target.value, 'EMAIL');
                      }}
                      onChange={(e) => {
                        setFieldValue('EMAIL', e?.target?.value);
                      }}
                    />
                    <ErrorMessage name="EMAIL" component={ErrorText} />
                    {noUserFound && users?.length === 0 && (
                      <span style={{ color: '#ff4d4f' }}>
                        No matching verified user found for the corporate.
                      </span>
                    )}
                  </Form.Item>
                </Col>
                <Col sm="12" md="2" lg="2">
                  <div style={{ marginTop: 40 }}>OR</div>
                </Col>
                <Col sm="10" md="5" lg="5">
                  <Form.Item
                    label={
                      <div>
                        Phone<span className="mandatorystar">*</span>
                      </div>
                    }
                  >
                    <Field
                      as={Input}
                      name="PHONE"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter')
                          // setFieldValue('PHONE', e?.target?.value);
                          onBlurSearchInput(e.target.value, 'PHONE');
                      }}
                      onChange={(e) => {
                        setFieldValue('PHONE', e?.target?.value);
                      }}
                    />
                    <ErrorMessage name="PHONE" component={ErrorText} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[14, 14]}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <div>
                        Name<span className="mandatorystar">*</span>
                      </div>
                    }
                  >
                    <Field as={Input} name="NAME" disabled />
                    <ErrorMessage name="NAME" component={ErrorText} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[14, 14]}>
                <Col span={24}>
                  <Label style={{ marginBottom: 10 }}>Group</Label>

                  <Field
                    as="select"
                    name="JP_CORPORATE_LOCATION"
                    onChange={(e) => {
                      setFieldValue('JP_CORPORATE_LOCATION', e?.target?.value);
                    }}
                    style={{
                      width: '100%',
                      height: '43px',
                      borderRadius: '6px',
                      padding: '8px',
                      backgroundColor: 'white',
                      border: '1px solid #d4d9df',
                      color: '#8b9bac',
                    }}
                  >
                    <option value=""></option>
                    {groups?.data?.map(
                      (group) =>
                        group?.IS_ACTIVE === 1 && (
                          <option key={group.ID} value={group.ID}>
                            {group.NAME}
                          </option>
                        ),
                    )}
                  </Field>

                  <ErrorMessage
                    name="JP_CORPORATE_LOCATION"
                    component={ErrorText}
                  />
                </Col>
              </Row>

              <Row gutter={[14, 14]}>
                <Col span={12} style={{ marginTop: 20, marginLeft: 20 }}>
                  <Field
                    as={Input}
                    type="checkbox"
                    name="IS_ACTIVE"
                    defaultChecked
                    onChange={(e) => {
                      setFieldValue('IS_ACTIVE', e.target.checked);
                    }}
                    checked={values?.IS_ACTIVE}
                  />
                  <Label>Is Active</Label>
                </Col>
              </Row>
              <Row gutter={[14, 14]}>
                <Col
                  span={12}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    style={{ color: '#fff', background: '#1890ff' }}
                    htmlType="submit"
                    loading={
                      isLoading || isLoadingUpdate || userSuggestionsLoading
                    }
                    disabled={isLoading || isLoadingUpdate}
                  >
                    <span>Submit</span>
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
}
